import React, { FunctionComponent, useState, useEffect, useCallback } from 'react';
import { getShowCompany } from '../../../services/companies';
import { Presentation } from './presentation';
import type { Props } from './types';
import type { CompanyData } from '../../../types/companies';
import { useAsyncLoading } from '../../../hooks/useAsyncLoading';

export const Component: FunctionComponent<Props> = (props) => {
  const { loading, execute } = useAsyncLoading();
  const [companyData, setCompanyData] = useState<CompanyData>({
    id: '',
    name: '',
    industry_ids: [],
    industries: [],
    description: '',
    recruitment_count: 0,
    event_count: 0,
    story_count: 0,
    logo_url: '',
  });

  useEffect(() => {
    execute(async () => {
      try {
        const data = await getShowCompany(props.companyId);
        setCompanyData(data);
      } finally {
        props.onLoad?.();
      }
    }).catch(() => {});
  }, [props.companyId, execute]);

  const renderCountItem = useCallback(
    (count: number, label: string, link: string, value: string) => {
      const isZero = count === 0;
      const itemClass = `new-company-index__card__detail-item ${isZero ? 'new-company-index__card__detail-item--zero' : ''}`;
      const labelClass = `new-company-index__card__detail-label ${isZero ? 'new-company-index__card__detail-label--zero' : ''}`;
      const countClass = `new-company-index__card__detail-count ${isZero ? 'new-company-index__card__detail-count--zero' : ''}`;

      return (
        <a href={link} className={`${itemClass} gtm-link-view-count`} data-event-name='link on screen' data-event="click" data-category={props.dataCategory} data-value={value} >
          <span className={labelClass}>{label}</span>
          <div className={countClass}>
            <span className="new-company-index__card__detail-count-number">{count}</span>
            <span className="new-company-index__card__detail-count-unit">件</span>
          </div>
        </a>
      );
    },
    [props.dataCategory, props.dataValue]
  );

  const presentationProps = {
    ...props,
    loading,
    companyData,
    renderCountItem,
  };

  return <Presentation {...presentationProps} />;
};
